import { SPSignup } from "../../../../src/components/sp-signup/content";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  SPSignup,
  Footer,
  React
};